import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { FunctionComponent, useContext } from 'react';
import { UserDetailsContext } from '../context/user-details/user-details';

// Route guard for org feature flags. Currently used to gate the Product Carbon
// Footprint surfaces so a direct URL respects the flag, matching the backend
// route-level gate and the navigation, which already hide it. If the flag is off
// the user is sent to the dashboard rather than shown a page they cannot use.
type OrganisationFeatureFlag = 'enableProductCarbonFootprint';

const RequireFeature: FunctionComponent<{ flag: OrganisationFeatureFlag }> = ({ flag }) => {
  const location = useLocation();
  const userDetailsContext = useContext(UserDetailsContext);
  const userDetails = userDetailsContext.userDetails;

  // While user details are still loading, render nothing rather than flashing a
  // redirect (the surrounding RequireAuth handles the unauthenticated case).
  if (!userDetails) {
    return null;
  }

  const enabled = !!userDetails.organisation?.[flag];
  return enabled
    ? <Outlet />
    : <Navigate to="/dashboard" state={{ from: location }} replace />;
};

export default RequireFeature;
